import 'fomantic-ui-less/definitions/modules/transition';
import 'fomantic-ui-less/definitions/modules/dropdown';

const dropdownWorkflowDefinitions = [];
const dropdownWorkflowTaskNames = [];

export default class FormNodeView {
    constructor(node, view, getPos) {
        this.view = view;
        this.getPos = getPos;
        this.node = node;
        const workflowDefinition = this.node.attrs.workflowDefinition || '';
        const taskNames = this.node.attrs.taskNames || '';

        this.workflowDefinitionsDropdown = document.createElement('select');
        this.workflowDefinitionsDropdown.className = 'ui fluid search selection dropdown';
        this.workflowDefinitionsDropdown.insertAdjacentHTML('beforeend', '<option value="">Select a workflow definition</option>');

        this.workflowTaskNamesDropdown = document.createElement('select');
        this.workflowTaskNamesDropdown.className = 'ui fluid search selection multiple dropdown';
        this.workflowTaskNamesDropdown.multiple = true;
        this.workflowTaskNamesDropdown.insertAdjacentHTML('beforeend', '<option value="">Select task names</option>');

        const workflowDefinitions = document.createElement('div');
        workflowDefinitions.className = 'ui secondary segment';

        const workflowDefinitionFields = document.createElement('div');
        workflowDefinitionFields.className = 'fields';

        const workflowDefinitionField = document.createElement('div');
        workflowDefinitionField.className = 'six wide field required';
        workflowDefinitionField.insertAdjacentHTML('afterbegin', '<label>Workflow definition</label>');
        workflowDefinitionField.appendChild(this.workflowDefinitionsDropdown);

        const workflowTaskNamesField = document.createElement('div');
        workflowTaskNamesField.className = 'ten wide field required';
        workflowTaskNamesField.insertAdjacentHTML('afterbegin', '<label>Task names</label>');
        workflowTaskNamesField.appendChild(this.workflowTaskNamesDropdown);

        workflowDefinitionFields.appendChild(workflowDefinitionField);
        workflowDefinitionFields.appendChild(workflowTaskNamesField);

        workflowDefinitions.appendChild(workflowDefinitionFields);
        workflowDefinitions.setAttribute('contenteditable', 'false');

        const form = document.createElement('form');
        form.className = 'ui form segment';

        const formContainer = document.createElement('div');
        formContainer.className = 'ui segments';
        formContainer.appendChild(workflowDefinitions);
        formContainer.appendChild(form);

        this.dom = formContainer;
        this.contentDOM = form;

        const applyWorkflowDefinitionChange = (text, value) => {
            if (workflowDefinition === value.trim()) {
                return;
            }

            const transaction = this.view.state.tr.setNodeMarkup(this.getPos(), undefined, {
                workflowDefinition: value.trim(),
            });
            this.view.dispatch(transaction);
        }

        $(this.workflowDefinitionsDropdown).dropdown({
            values: dropdownWorkflowDefinitions,
            variation: 'scrolling',
            action: applyWorkflowDefinitionChange,
            duration: 0
        }).dropdown('set selected', workflowDefinition);

        const applyWorkflowTaskNameChange = (text, value) => {
            if (taskNames === value.trim()) {
                return;
            }

            const transaction = this.view.state.tr.setNodeMarkup(this.getPos(), undefined, {
                taskNames: value.trim(),
            });
            this.view.dispatch(transaction);
        }

        $(this.workflowTaskNamesDropdown).dropdown({
            values: dropdownWorkflowTaskNames,
            variation: 'scrolling',
            action: applyWorkflowTaskNameChange,
            duration: 0
        }).dropdown('set selected', taskNames);
    }

    ignoreMutation() {
        return true;
    }

    destroy() {
        $(this.workflowDefinitionsDropdown).dropdown('destroy');
        $(this.workflowTaskNamesDropdown).dropdown('destroy');
        this.dom.remove();
        this.contentDOM.remove();
        delete this.dom;
        delete this.contentDOM;
    }
}